import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  ProcessStageTable,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

export const ProcessStage = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    role: "",
    stageName: "",
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [processStage, setProcessStage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      role: "",
      stageName: "",
      status: "",
    });
  };

  const [manageRole, setManageRole] = useState([]);
  const getManageRole = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/role`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setManageRole(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getProcessStage = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/stage?platform=TREASURY`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setProcessStage(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addProcessStage = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/stage`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getProcessStage();
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success({
          content: "Stage Created",
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      const err = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      resetForm();
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const editProcessStage = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/stage/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getProcessStage();
        setIsLoadBtn(false);
        setIsLoading(false);
        resetForm();
        message.success({
          content: "Stage Edited",
          style: {
            marginTop: "20vh",
          },
        });
      }
    } catch (error) {
      const err = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      resetForm();
      message.error({
        content: err.data.message,
        style: {
          marginTop: "20vh",
        },
      });
    }
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const onFormSubmit = () => {
    addProcessStage({ ...formData, platform: "TREASURY" });
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editProcessStage({ ...formData, platform: "TREASURY" });
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      role: items.role.id,
      stageName: items.stageName,
      status: items.status,
    });
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = processStage?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getProcessStage();
    getManageRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusOptions = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ];

  const roleOptions = manageRole?.map((role) => ({
    label: role.roleName,
    value: role.id,
  }));

  return (
    <React.Fragment>
      <Head title="Project List"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Process Stage</BlockTitle>
                <AllowAccess allowedRights={["CREATE_STAGE"]}>
                <Button color="primary" onClick={() => setModal({ add: true })}>
                  <Icon name="plus" />
                  <span>Create Process Stage</span>
                </Button></AllowAccess>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ProcessStageTable
                processStage={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
              />
            )}
          </Card>
          <div className="card-inner">
            {processStage && processStage.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={processStage.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Process Stage Found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Process Stage</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Stage name</label>
                      <input
                        type="text"
                        name="stageName"
                        placeholder="Stage name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.stageName && <span className="invalid">{errors.stageName.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Role</label>
                      <RSelect options={roleOptions} onChange={(e) => setFormData({ ...formData, role: e.value })} />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Edit Stage</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Stage name</label>
                      <input
                        type="text"
                        name="stageName"
                        defaultValue={formData.stageName}
                        placeholder="Stage name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {/* {errors.stageName && <span className="invalid">{errors.stageName.message}</span>} */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Role</label>
                      <RSelect
                        options={roleOptions}
                        value={roleOptions.filter(({ value }) => value === formData.role)[0]}
                        onChange={(e) => setFormData({ ...formData, role: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                        value={statusOptions.filter(({ value }) => value === formData.status)[0]}
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
